import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { ITAFBookS2 } from './taf-book-s2-list';

import { HttpHelper } from '../../../shared/http-helper';

import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';

@Injectable()
export class TAFBookS2Service {

    //need to have this somewhere besides hardcoded in here

    //private _tafBookS2Url = ` http://localhost:55706/api/systemmanagement/TAFBookS2`;
    private _tafBookS2Url = `api/systemmanagement/TAFBookS2`;
    
    constructor(private httpHelper: HttpHelper) { }

    getTAFBookS2(): Observable<ITAFBookS2> {
         return this.httpHelper.get(`${this._tafBookS2Url}`)
             //.map((response: Response) => <ITAFBookS2> response.json())
             //.do(data => console.log('ITafBookS2: ' +  JSON.stringify(data)))
             //.catch(this.handleError);
    }

   
    private handleError(error: Response) {
         // in a real world app, we may send the server to some remote logging infrastructure
         // instead of just logging it to the console
                 
         console.error(error);
         return Observable.throw(error.json().error || 'Server error');
    }
}


/** WEBPACK FOOTER **
 ** ./app/system-management/tafbooks/taf-book-s2/taf-book-s2.service.ts
 **/